<template>
  <div class="visitor_my">
    <div class="tit">
      <span>我的访客</span>
    </div>
    <div class="body_content" v-if="user.role === 'UserRoleOrdinary'">
      <div class="btns">
        <div class="btn_left">
          <!-- <div class="tip">您目前为普通用户，请前往进行员工认证或者企业认证</div> -->
          <el-button type="primary" @click="employeeCertify">认证为员工</el-button>
          <el-button type="primary" @click="enterpriseCertify">认证为企业</el-button>
        </div>
      </div>
    </div>
    <div class="body_content" v-else>
      <div class="btns">
        <div class="btn_left">
          <el-button type="primary" @click="add">我要邀约</el-button>
        </div>
      </div>
      <!-- 表格数据 -->
      <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable>
    </div>
    <el-dialog title="查看意见" :visible.sync="dialogVisible" width="600px" center>
      <span v-if="row && row.examine_remark" v-cloak>{{row.examine_remark}}</span>
      <span v-else>暂无</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myTable from "@/components/my_table";
export default {
  components: {
    myTable
  },
  data() {
    return {
      dialogVisible:false,
      row:{},
      tableObj: {
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "取消邀请",
            funcName: "cancelInvite",
            formatter: row => {
              /* 获取当前时间戳 */

              let nowDate = new Date().getTime();
              /* 获取来访时间戳 */

              let visitorDate = new Date(row.visitor_date).getTime();
              /* 通过状态 */

              let success = "IdentityCertifieStatussuccess";
              /* 审核状态 */

              let submitted = "IdentityCertifieStatusSubmitted";
              /* 在审核中状态或者审核成功并且在来访日期前 */

              return (
                row.status_code == submitted ||
                (row.status_code == success && nowDate < visitorDate)
              );
            }
          },
          {
            name: "恢复邀请",
            funcName: "recoverlInvite",
            formatter: row => {
              /* 当前时间格式化 */

              let nowDate = new Date().getTime();
              /* 来访时间 */

              let visitorDate = new Date(row.visitor_date).getTime();
              /* 取消状态 */

              let cancel = "IdentityCertifieStatusCancel";
              /* 如果来访时间大于当前时间并且为已取消状态，则显示恢复邀请 */

              return nowDate < visitorDate && row.status_code == cancel;
            }
          },
          {
            name: "查看意见",
            funcName: "see",
            formatter: function(row) {
              return row.status_code === "IdentityCertifieStatusFailed";
            }
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "contact",
            label: "访客姓名"
          },
          {
            prop: "visitor_date",
            label: "访问时间",
            width: "90px"
          },
          {
            prop: "company",
            label: "所属单位"
          },
          {
            prop: "contact_phone",
            label: "联系方式",
            width: "115px"
          },
          {
            prop: "create_date",
            label: "提交时间",
            width: "90px"
          },
          {
            prop: "remark",
            label: "来访事由",
            width: "130px"
          },
          {
            prop: "car_num",
            label: "车牌号码"
          },
          {
            prop: "status_name",
            label: "审核状态"
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      },
      user: "" //用户
    };
  },
  created() {
    if (this.$store.state.info) {
      this.initMsg(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("initMsg");
    }
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods: {
    /* 跳转我要邀约 */

    add() {
      this.$router.push({
        path:
          "/personal_center/park_user/visitor_registration/visitor_invitation"
      });
    },

    /* 获取访客列表 */
    getList() {
      let obj = {
        ...this.tableObj.layerpageinfo
      };
      this.api.getFrontVisitorApply(obj).then(res => {
        console.log(res);
        if (res.error.err_code != 0) return;
        let list = res.obj.list;
        console.log(res);
        this.tableObj.list = list.length ? list : [];
        this.tableObj.layerpageinfo.total = res.obj.totalSize;
      });
    },
    btnClick(btn) {
      // 已提交审核状态
      let submitted = "IdentityCertifieStatusSubmitted";
      // 通过审核状态
      let success = "IdentityCertifieStatussuccess";
      // 取消审核状态
      let canceled = "IdentityCertifieStatusCancel";
      // 当前时间戳
      let nowDate = new Date().getTime();
      // 来访时间戳
      let visitorDate = new Date(btn.row.visitor_date).getTime();
      switch (btn.btnFuncName) {
        // 取消邀请
        case "cancelInvite":
          console.log(btn.row);
          // 已提交状态或者通过状态同时来访时间大于当前时间，进行取消邀请
          if (
            btn.row.status_code === submitted ||
            (btn.row.status_code === success && nowDate < visitorDate)
          ) {
            this.$confirm("您正在取消邀请, 是否继续?", "提示", {
              confirmButtonText: "继续",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                // 取消邀请
                let obj = {
                  id: btn.row.id,
                  operation: "IdentityCertifieStatusCancel"
                };
                this.api.cancel(obj).then(res => {
                  if (res.error.err_code != 0) return;
                  this.$message({
                    type: "success",
                    message: "取消成功！"
                  });
                  // 重新获取列表
                  this.getList();
                });
              })
              .catch(() => {
                return;
              });
          }
          break;
        // 恢复邀请
        case "recoverlInvite":
          // 取消状态并且来访时间大于当前时间，进行恢复邀请操作
          if (btn.row.status_code === canceled && nowDate < visitorDate) {
            console.log("恢复邀请", nowDate - visitorDate);
            this.$confirm("您确定要恢复邀请吗？", "提示", {
              confirmButtonText: "恢复",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                let obj = {
                  id: btn.row.id,
                  operation: "IdentityCertifieStatusSubmitted"
                };
                this.api.cancel(obj).then(res => {
                  if (res.error.err_code != 0) return;
                  this.$message({
                    type: "success",
                    message: "恢复成功!"
                  });
                  this.getList();
                });
              })
              .catch(() => {
                return;
              });
          }
          break;
          case "see":
          this.row = btn.row;
          this.dialogVisible = true;
          break;
      }
    },
    // 初始化信息
    initMsg() {
      this.getList();
      this.user = this.$store.state.info;
    },
    // 监听个人信息
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 员工认证
    employeeCertify() {
      this.$router.push({ name: "employee_certification" });
    },
    // 企业认证
    enterpriseCertify() {
      this.$router.push({ name: "enterprise_certification" });
    }
  }
};
</script>

<style lang="scss">
@import "../../../index.scss";
.visitor_my {
  .body_content {
    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .btns {
      .btn_left {
        .tip {
          line-height: 40px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>